export class LanguageState {
  LID: string = '';
  Authenticated: boolean = false;
  RTL: boolean = false;
}
